import { Col, Form, Row, Tabs } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ROOT_URL } from "../../constants/api";
import { nofication } from "./../../commons/Nofication";
import MainLayout from "./../../components/mainLayout";
import { authApis } from "./../../services/authApi";
import "./index.scss";
import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Line, Pie } from "react-chartjs-2";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: "top",
        },
        title: {
            display: true,
            text: "Chart.js Line Chart",
        },
    },
};

const labels = ["January", "February", "March", "April", "May", "June", "July"];

export const data = {
    labels,
    datasets: [
        {
            label: "Tuần",
            data: [1, 2, 3, 4, 5, 6],
            borderColor: "rgb(255, 99, 132)",
            backgroundColor: "rgba(255, 99, 132, 0.5)",
        },
        {
            label: "Tháng",
            data: [10, 4, 6, 8, 9, 19],
            borderColor: "rgb(53, 162, 235)",
            backgroundColor: "rgba(53, 162, 235, 0.5)",
        },
    ],
};

export const dataPie = {
    labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
    datasets: [
        {
            label: "# of Votes",
            data: [12, 19, 3, 5, 2, 3],
            backgroundColor: [
                "rgba(255, 99, 132, 0.2)",
                "rgba(54, 162, 235, 0.2)",
                "rgba(255, 206, 86, 0.2)",
                "rgba(75, 192, 192, 0.2)",
                "rgba(153, 102, 255, 0.2)",
                "rgba(255, 159, 64, 0.2)",
            ],
            borderColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
            ],
            borderWidth: 1,
        },
    ],
};

const Register = () => {
    const [fileList, setFileList] = useState();
    const [form] = Form.useForm();
    let { id } = useParams();
    const [value, onChange] = useState(new Date());
    const onChangeContentValue = (lang) => {
        console.log("lang");
    };
    useState(() => {
        console.log(id);
        if (id) {
            authApis
                .getDetailNews(id)
                .then((data) => {
                    if (data.status_code === 200) {
                        form.setFieldsValue(data.news);
                        setImageUrl(
                            data.news.image ? ROOT_URL + data.news.image : ""
                        );
                    } else {
                        nofication(
                            "error",
                            "Thất bại",
                            "Vui lòng kiểm tra lại thông tin !"
                        );
                    }
                })
                .catch((errors) => {
                    nofication(
                        "error",
                        "Thất bại",
                        "Không kết nối được server"
                    );
                    console.log(errors);
                });
        }
    });

    const onFinish = async () => {
        const values = form.getFieldValue();
        console.log(values);
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            formData.append(key, values[key]);
        }
        if (id) {
            formData.append("id", id);
        }
        formData.append("logo", fileList);
        await authApis
            .news(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication("success", "Thành công", "Cập nhật thành công!");
                } else {
                    nofication(
                        "error",
                        "Thất bại",
                        "Vui lòng kiểm tra lại thông tin !"
                    );
                }
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Không kết nối được server");
                console.log(errors);
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Dashboard"
            link="/dashboard/"
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                colon={true}
            >
                <Row>
                    <Col span={24} className='main-min-height dashboard'>
                        <Row
                            style={{
                                backgroundColor: "white",
                                padding: "10px",
                                borderRadius: "13px",
                                marginTop: 20,
                            }}
                        >
                            <Col span={10} className='calendar-top' xs={24} sm={24} md={24} lg={24}>
                                <Calendar
                                    onChange={onChange}
                                    value={value}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
